import styled from "styled-components";
import {StyledBaseProps} from "@betrue/shared/interfaces";
import React from "react";
import {Rating} from "@material-ui/lab";
import SentimentVeryDissatisfiedIcon from "@material-ui/icons/SentimentVeryDissatisfied";
import SentimentDissatisfiedIcon from "@material-ui/icons/SentimentDissatisfied";
import SentimentSatisfiedIcon from "@material-ui/icons/SentimentSatisfied";
import SentimentSatisfiedAltIcon from "@material-ui/icons/SentimentSatisfiedAltOutlined";
import SentimentVerySatisfiedIcon from "@material-ui/icons/SentimentVerySatisfied";
import PropTypes from "prop-types";


export interface UserRatingViewProps extends StyledBaseProps {
  defaultValue: number | undefined
  onRating: (rating: number) => void
  readOnly: boolean
}

const customIcons = {
  1: {
    icon: <SentimentVeryDissatisfiedIcon/>,
    label: 'Very Dissatisfied',
    color: 'warning'
  },
  2: {
    icon: <SentimentDissatisfiedIcon/>,
    label: 'Dissatisfied',
    color: 'warning'
  },
  3: {
    icon: <SentimentSatisfiedIcon/>,
    label: 'Neutral',
    color: 'none'
  },
  4: {
    icon: <SentimentSatisfiedAltIcon/>,
    label: 'Satisfied',
    color: 'success'
  },
  5: {
    icon: <SentimentVerySatisfiedIcon/>,
    label: 'Very Satisfied',
    color: 'success'
  },
};

function IconContainer(props) {
  const {value, ...other} = props;
  return <span {...other}
               className={`${customIcons[value || value === 0 ? value : 3].color} ${other.className}`}>{customIcons[value || value === 0 ? value : 3].icon}</span>;
}

IconContainer.propTypes = {
  value: PropTypes.number.isRequired,
};

export const UserRatingView = styled((props: UserRatingViewProps) => (
  <div className={props.className}>
    {!props.readOnly ? <Rating
      name="customized-icons"
      readOnly={props.readOnly}
      defaultValue={props.defaultValue}
      onChange={(e, v) => props.onRating(v)}
      getLabelText={(value) => customIcons[value].label}
      IconContainerComponent={IconContainer}
    /> : IconContainer({value: props.defaultValue})}

  </div>
))`
& .warning {
  color: ${props => props.theme.colors.warning};
}

  .success {
    color: ${props => props.theme.colors.success};
  }

`
